import { CLASSES_ALLOW_MORE_SUBJECTS } from "../../new-subscription/v2/ChangePlanBottomModal"

/**
 * Jusqu'en 3ᵉ, un élève peut suivre plus de matières que d'heures : au-delà
 * du volume, l'accompagnement devient du suivi de devoirs. Au lycée, une
 * matière veut son heure.
 */
export const allowsMoreSubjectsThanHours = (studentClass) =>
    CLASSES_ALLOW_MORE_SUBJECTS.includes(studentClass)

/**
 * Ce volume porte-t-il ces matières ? La règle du compositeur, qui vaut pour
 * tout volume qu'un réglage ferait prendre — à la réservation aussi.
 */
export const subjectsFitHours = (studentClass, subjectCount, weeklyHours) =>
    allowsMoreSubjectsThanHours(studentClass) || subjectCount <= weeklyHours

/**
 * Ce qui manque à un volume pour s'écrire sans repasser par le compositeur :
 * `"hours"` s'il n'y en a pas (le format ne vend pas ce volume), `"subjects"`
 * s'il ne porte pas les matières, `"slots"` s'il dépasse les créneaux donnés ;
 * `null` quand rien ne manque. Les écrans qui changent la formule hors du
 * compositeur — la page du format, la réservation — n'écrivent jamais un
 * choix à qui il manque quelque chose : c'est au compositeur qu'il se règle.
 *
 * `slotCount` à zéro : des créneaux qu'on ne connaît pas (dossier repris sans
 * eux) ne bloquent rien.
 */
export const formulaGap = ({
    studentClass,
    subjectCount,
    slotCount = 0,
    weeklyHours,
}) => {
    if (!weeklyHours) return "hours"
    if (!subjectsFitHours(studentClass, subjectCount, weeklyHours))
        return "subjects"
    if (slotCount > 0 && slotCount < weeklyHours) return "slots"
    return null
}
